import { render, staticRenderFns } from "./IngredientUnitConversionCompareDialog.vue?vue&type=template&id=11137561&scoped=true&"
import script from "./IngredientUnitConversionCompareDialog.vue?vue&type=script&lang=js&"
export * from "./IngredientUnitConversionCompareDialog.vue?vue&type=script&lang=js&"
import style0 from "./IngredientUnitConversionCompareDialog.vue?vue&type=style&index=0&id=11137561&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11137561",
  null
  
)

export default component.exports